<template>
  <div class="UsersLists">
    <h1 class="text-center my-7">لیست کاربران</h1>
    <v-card class="pa-3 mb-10">
      <div class="d-flex align-center">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="جستجو"
          single-line
          hide-details
          class="mb-3 ml-5"
        ></v-text-field>
        <v-btn depressed color="success" :disabled="selected.length === 0">
          <download-csv
            :data="selected"
            name="لیست کاربران.csv"
            :labels="csvlabels"
            :fields="csvfields"
            class="d-flex align-center"
          >
            <v-icon class="ml-2 text-body-2"
              >mdi-content-save-settings-outline</v-icon
            >
            <small>ذخیره موارد انتخاب شده</small>
          </download-csv>
        </v-btn>
      </div>
      <v-data-table
        v-model="selected"
        :headers="userHeaders"
        :items="users"
        :items-per-page="10"
        :rows-per-page-items="[10, 50, 200, -1]"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right'
        }"
        :search="search"
        :loading="loading"
        loading-text="دارم آماده ش میکنم ... صبر کن -_-"
        show-select
        item-key="_id"
      >
        <template v-slot:[`item.orderCount`]="{ item }">
          <number-component :number="item.orderCount"></number-component>
        </template>
        <template v-slot:[`item.orderSum`]="{ item }">
          <number-component :number="item.orderSum" unit="ريال"></number-component>
        </template>
        <template v-slot:[`item.joinDate`]="{ item }">
          <persian-date :date="item.joinDate" />
        </template>
      </v-data-table>
    </v-card>
    <div class="text-center">
      <v-btn
        outlined
        depressed
        color="primary"
        router
        :to="{
          name: 'UsersReport'
        }"
      >
        بازگشت
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: "users-lists-component",
  data() {
    return {
      loading: true,
      users: [],
      userHeaders: [
        {
          text: "نام و نام خانوادگی",
          value: "fullname",
          align: "center",
          filterable: true
        },
        {
          text: "شماره همراه",
          value: "username",
          align: "center",
          filterable: true
        },
        {
          text: "تاریخ ثبت نام",
          value: "joinDate",
          align: "center",
          filterable: true
        },
        { text: "استان", value: "state", align: "center", filterable: true },
        { text: "شهرستان", value: "city", align: "center", filterable: true },
        { text: "مدرسه", value: "school", align: "center", filterable: true },
        {
          text: "تعداد خرید",
          value: "orderCount",
          align: "center",
          filterable: true
        },
        {
          text: "مجموع خرید",
          value: "orderSum",
          align: "center",
          filterable: true
        }
      ],
      search: "",
      selected: [],
      csvfields: [
        "fullname",
        "username",
        "joinDate",
        "state",
        "city",
        "school",
        "orderCount",
        "orderSum"
      ],
      csvlabels: {
        fullname: "نام و نام خانوادگی",
        username: "شماره همراه",
        joinDate: "تاریخ ثبت نام",
        state: "استان",
        city: "شهرستان",
        school: "مدرسه",
        orderCount: "تعداد خرید",
        orderSum: "مجموع خرید"
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.get("/user/getusers").then((res) => {
        this.users = res.data.users;
        this.loading = false;
      });
    }
  }
};
</script>
